import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/api.form.actions';

import Task from './Task';

import { TypeBooleanIcon } from '../../../../images/icons/WrapSvg';

// eslint-disable-next-line
import style from './_styles.css';



class Boolean extends React.Component {
    state = {
        valor: undefined,
        intervalId: undefined,
        message: undefined,
        desactivado: false,
    };

    static getDerivedStateFromProps(props, state) {
        const { data, parentDeactivated } = props;
        if (data !== state.data || parentDeactivated !== state.parentDeactivated) {
            state.valor = data.valor === null ? undefined : data.valor;
            state.desactivado = data.desactivado || parentDeactivated;
            state.comentario = data.comentario ? data.comentario : '';
            state.parentDeactivated = parentDeactivated;
            state.data = data;
            return state;
        }
        return null;
    }

    handleClick = (name, input, inverso) => (event) => {
        let { valor } = this.state;
        valor =
            valor === undefined
                ? input
                : valor === true && input === false
                ? false
                : valor === false && input === true
                ? true
                : undefined;
        this.props.setValue(name, valor, '', false, {}, ((valor === true && !inverso) || (valor === false && inverso)) ? 100 : 0);
        this.setState({ valor: valor });
    };

    handleDeactive = (data, checked) => {
        this.props.setValue(data.codigo, undefined, '', checked, {});
        this.setState({ desactivado: checked, valor: undefined });
    };

    component = (name, intl, disabled, valor, inverso) => {
        return (
            <React.Fragment>
                <Button
                    variant="contained"
                    className={
                        'flex_fixed_column_44  display_flex elements_center hand border-yes ' +
                        (valor === true ? 'bg_bluish c_white ' : 'bg_white c_bluish ')
                    }
                    onClick={this.handleClick(name, true, inverso)}
                >
                    <FormattedMessage id={'type_label_boolean_yes'} />
                </Button>
                <Button
                    variant="contained"
                    className={
                        'flex_fixed_column_44  display_flex elements_center border-no  hand ' +
                        (valor === false ? 'bg_bluish c_white ' : 'bg_white c_bluish ')
                    }
                    onClick={this.handleClick(name, false, inverso)}
                >
                    <FormattedMessage id={'type_label_boolean_no'} />
                </Button>
            </React.Fragment>
        );
    };

    render() {
        const { last, data, editable, parentDeactivated, intl } = this.props;
        const { valor, desactivado } = this.state;
        return (
            <Task
                key={data.codigo}
                data={data}
                red={data.alertable && ((data.inverso && valor) || (!data.inverso && valor === false))}
                value={valor}
                desactivado={desactivado || parentDeactivated}
                icon={<TypeBooleanIcon color="primary" />}
                text="type_label_boolean"
                last={last}
                editable={editable}
                column={this.component(
                    data.codigo,
                    intl,
                    !editable || data.disabled || desactivado || parentDeactivated,
                    valor,
                    data.inverso
                )}
                parentDeactivated={parentDeactivated}
                onClick={() => this.handleClick(data.codigo)}
                onDeactive={this.handleDeactive}
            />
        );
    }
}

Boolean.propTypes = {
    instance: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        instance: state.instance,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Boolean);



// WEBPACK FOOTER //
// ./src/components/complex/forms/types/Boolean.js